export default __webpack_public_path__ + "CircularCustCapNum-LightItalic.bdc02410e5944a01ac1b633b86713171.eot";